import { render } from "./client-blacklist-modal.vue?vue&type=template&id=76d6d1a4&scoped=true&ts=true"
import script from "./client-blacklist-modal.vue?vue&type=script&lang=ts"
export * from "./client-blacklist-modal.vue?vue&type=script&lang=ts"

import "./client-blacklist-modal.vue?vue&type=style&index=0&id=76d6d1a4&lang=scss&scoped=true"

import exportComponent from "/data/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-76d6d1a4"]])

export default __exports__